var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6816 5.57043C25.0645 4.95297 24.3317 4.46316 23.5252 4.12899C22.7187 3.79481 21.8542 3.6228 20.9812 3.6228C20.1082 3.6228 19.2438 3.79481 18.4373 4.12899C17.6307 4.46316 16.898 4.95297 16.2808 5.57043L15 6.85126L13.7191 5.57043C12.4725 4.3238 10.7817 3.62345 9.01873 3.62345C7.25573 3.62345 5.56494 4.3238 4.31831 5.57043C3.07169 6.81705 2.37134 8.50784 2.37134 10.2708C2.37134 12.0338 3.07169 13.7246 4.31831 14.9713L15 25.6529L25.6816 14.9713C26.2991 14.3541 26.7889 13.6213 27.1231 12.8148C27.4573 12.0083 27.6293 11.1438 27.6293 10.2708C27.6293 9.39784 27.4573 8.53338 27.1231 7.72687C26.7889 6.92036 26.2991 6.18759 25.6816 5.57043Z",
    fill: "#705EC0",
    stroke: "#1E1E1E",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/Heart2.20029ae2626b8d9a5a4422be3629ac26.svg";
export { ForwardRef as ReactComponent };